var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndicationDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.659,
    height: 42.659,
    viewBox: "0 0 42.659 42.659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_466",
    "data-name": "Trac\\xE9 466",
    d: "M47.659,9.3,43.363,5,26.33,22.033,9.3,5,5,9.3,22.033,26.33,5,43.363l4.3,4.3L26.33,30.626,43.363,47.659l4.3-4.3L30.626,26.33Z",
    transform: "translate(-5 -5)",
    fill: "#ff3b00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicationDislike);
export default __webpack_public_path__ + "static/media/indicationDislike.2646282a244b07a567117f0a929d3513.svg";
export { ForwardRef as ReactComponent };